
export { useSMID } from "/home/runner/work/apollo/apollo/packages/core/ui/src/hooks/use-smid/use-smid.tsx"